@use '~/assets/css/media/media.scss' as *;

.public-empty-legs {
    .blue-block_padding {
        height: auto;
        max-width: 100%;
        padding: 24px 18px;
        background: linear-gradient(68.29deg, #0a3c93 0.29%, #2368cd 118.76%);

        @media (--medium) {
            height: 64px;
            padding: 10px 18px;
        }
    }

    .container {
        padding: 20px 8px 48px;

        @media (--large) {
            padding: 20px 8px 64px;
        }
    }

    &__content.container {
        max-width: 1216px;
        margin: 16px auto 0;
    }

    &__title {
        margin: 0 0 20px;
        font-size: 28px;
        line-height: 1.25;

        @media (--medium) {
            font-size: 32px;
        }
    }

    &__introduction {
        margin: 0 0 24px;
        padding: 18px 20px;
        border: 1px solid rgb(11 61 148 / 12%);
        border-radius: 12px;
        background: #ffffff;

        h2 {
            margin: 0 0 8px;
            color: #11192b;
            font-size: 18px;
            line-height: 1.35;
        }

        p {
            max-width: 1040px;
            margin: 0;
            color: #11192bcc;
            font-size: 14px;
            line-height: 1.65;
        }
    }

    &__introduction-links {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 20px;
        margin-top: 12px;

        a,
        button {
            color: #0b3d94;
            font-size: 13px;
            font-weight: 700;
        }

        button {
            padding: 0;
            border: 0;
            background: transparent;
            font-family: inherit;
            text-align: left;
            cursor: pointer;
        }
    }

}
